import { gql } from '@apollo/client';

export const createAmendmentMutation = gql`
  mutation CreateAmendment($input: CreateAmendmentInput!) {
    production {
      createAmendment(input: $input)
    }
  }
`;

export const createCancellationAmendmentMutation = gql`
  mutation createCancellationAmendment($input: CreateAmendmentInput!) {
    production {
      createCancellationAmendment(input: $input)
    }
  }
`;

export const cancelAmendmentMutation = gql`
  mutation CancelAmendment($amendmentId: String!) {
    production {
      cancelAmendment(amendmentId: $amendmentId)
    }
  }
`;

export const calculateAmendmentMutation = gql`
  mutation CalculateAmendment(
    $amendmentId: String!
    $input: CalculateAmendmentInput!
  ) {
    production {
      calculateAmendment(amendmentId: $amendmentId, input: $input)
    }
  }
`;

export const calculateCancellationAmendmentMutation = gql`
  mutation CalculateCancellationAmendment(
    $input: CalculateCancellationAmendmentInput!
  ) {
    production {
      calculateCancellationAmendment(input: $input)
    }
  }
`;

export const confirmAmendmentMutation = gql`
  mutation ConfirmAmendment(
    $amendmentId: String!
    $input: ConfirmAmendmentInput!
  ) {
    production {
      confirmAmendment(amendmentId: $amendmentId, input: $input) {
        content
        contentType
        fileName
      }
    }
  }
`;

export const confirmAmendmentCancellationMutation = gql`
  mutation ConfirmCancellationAmendment(
    $input: ConfirmCancellationAmendmentInput!
  ) {
    production {
      confirmCancellationAmendment(input: $input) {
        content
        contentType
        fileName
      }
    }
  }
`;

export const modifyCancellationAmendmentMutation = gql`
  mutation ModifyCancellationAmendment($input: ModifyAmendmentInput!) {
    production {
      modifyCancellationAmendment(input: $input)
    }
  }
`;

export const cancelCancellationAmendmentMutation = gql`
  mutation CancelCancellationAmendment($amendmentId: String!) {
    production {
      cancelCancellationAmendment(amendmentId: $amendmentId)
    }
  }
`;

export const uploadAmendmentMedicalInsuredList = gql`
  mutation uploadAmendmentMedicalInsuredList(
    $document: Upload!
    $documentName: String!
    $amendmentId: String!
  ) {
    production {
      uploadAmendmentMedicalInsuredList(
        amendmentId: $amendmentId
        documentName: $documentName
        document: $document
      ) {
        column
        description
        row
        type
      }
    }
  }
`;
